/**
 * API v4 (student) — OpenAPI + React Query
 *
 * Type, hook, model đều sinh từ spec `/v4/student/openapi.json`; đừng viết tay type
 * request/response. Sinh lại bằng `pnpm openapi-v4-gen` (hoặc tự chạy trong `pnpm dev`).
 *
 * @example
 * ```tsx
 * import { useStudentListPublicAwards, useStudentGetWisdomStoneBalance } from '@/api/v4';
 *
 * const { data } = useStudentListPublicAwards({
 *   path: { learner_profile_id: 1 },
 *   query: { limit: 20, page: 1 },
 * });
 * ```
 */

// Client REST (cookie-based)
export { default as apiClientV4 } from './client';

// Hook nền, dùng khi cần gọi một path chưa có hook sinh sẵn
export {
  ApiError,
  useApiDelete,
  useApiMutation,
  useApiPatch,
  useApiPost,
  useApiPut,
  useApiQuery,
} from './hooks';

// Hook sinh từ spec — một hook cho mỗi endpoint
export * from '../__generated__/hooks-v4';

// Model/type sinh từ spec
export * from '../__generated__/models-v4';
export * from '../__generated__/responses-v4';

export type { components, paths } from '../__generated__/openapi-v4';
